import { Flex, useBreakpointValue } from '@chakra-ui/react';
import { GrowthIcon, CoinIcon, DiscountTagIcon } from 'src/assets/icons';
import { valuePromotion } from 'src/constants/promotion';
import { AdvantageCard } from './components/AdvantageCard';
import { CardText } from './components/CardText';

export const ReferralAdvantages = () => {
  const bigFontSize = useBreakpointValue({
    base: '2xl',
    xl: '3xl',
  });

  return (
    <Flex gap={{ base: 3, lg: 4 }} flexDir={{ base: 'column', lg: 'row' }}>
      <AdvantageCard
        color="blue.100"
        icon={<GrowthIcon boxSize="35px" />}
        content={
          <>
            <CardText>A cada 5 indicações ganhe*</CardText>
            <CardText fontSize={bigFontSize} fontWeight="800">
              3+ novos
            </CardText>
            <CardText>clientes da base Inventa</CardText>
          </>
        }
      />
      <AdvantageCard
        color="green.100"
        icon={<DiscountTagIcon boxSize="35px" />}
        content={
          <>
            <CardText>Você garante</CardText>
            <CardText>
              <CardText fontSize={bigFontSize} fontWeight="800">
                0%
              </CardText>
              &nbsp;comissão***
            </CardText>
            <CardText>nas suas vendas</CardText>
          </>
        }
      />
      <AdvantageCard
        color="yellow.100"
        icon={<CoinIcon boxSize="35px" />}
        content={
          <>
            <CardText>Presenteie indicados com</CardText>
            <CardText fontSize={bigFontSize} fontWeight="800">
              R${valuePromotion}
            </CardText>
            <CardText>na primeira compra**</CardText>
          </>
        }
      />
    </Flex>
  );
};
